// extracted by mini-css-extract-plugin
export default {"landingTitleContainer":"kHle_uYTej4ckF8wU6WQ","landingPlannersAvatars":"fsEy_BYLtRxMPV9l5maE","landingPlannersAvatar":"GDVWYgNfPpbi2ONuOKCJ"};